import { Phone, WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { SITE, WA_LINK } from "@/constants/site";

const trackContact = () => {
  if (window.fbq) window.fbq("track", "Contact");
};

export default function StickyCTA({ onEnquire }) {
  return (
    <>
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        onClick={trackContact}
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-50 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] transition-transform duration-200 hover:scale-110 md:flex"
      >
        <WhatsappLogo size={26} weight="fill" />
      </a>
      <div data-testid="mobile-sticky-cta" className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-black/5 bg-white/95 backdrop-blur-xl md:hidden">
        <a
          href={`tel:${SITE.phoneRaw}`}
          data-testid="mobile-call-btn"
          className="flex flex-col items-center gap-1 py-3 text-forest"
        >
          <Phone size={20} weight="fill" />
          <span className="text-[10px] font-bold uppercase tracking-widest">Call</span>
        </a>
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-whatsapp-btn"
          onClick={trackContact}
          className="flex flex-col items-center gap-1 border-x border-black/5 py-3 text-[#1faf54]"
        >
          <WhatsappLogo size={20} weight="fill" />
          <span className="text-[10px] font-bold uppercase tracking-widest">WhatsApp</span>
        </a>
        <button
          data-testid="mobile-enquire-btn"
          onClick={onEnquire}
          className="flex flex-col items-center gap-1 bg-forest py-3 text-gold"
        >
          <EnvelopeSimple size={20} weight="fill" />
          <span className="text-[10px] font-bold uppercase tracking-widest">Enquire</span>
        </button>
      </div>
    </>
  );
}
